module.exports = __webpack_public_path__ + "img/BK_BODEGA_AURRERA_hogar.29b45582.png";